import React, { Component } from "react";
import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  CardTitle,
  CardText
} from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";

const styles = theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper
  },
  gridList: {
    flexWrap: "nowrap",
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: "translateZ(0)"
  },
  title: {
    color: theme.palette.primary.light
  },
  titleBar: {
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, " +
      "rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)"
  },
  icon: {
    color: "white"
  }
});

class Card2 extends Component {
  render() {
    return (
      <Card className={styles.root}>
        <CardHeader
          style={{ display: "flex", alignItems: "center" }}
          title={
            <h1
              style={{
                fontWeight: 400,
                fontSize: "1.6em",
                color: "slategray"
              }}>
              {this.props.title}
            </h1>
          }
          avatar={this.props.logo}
        />
        <CardMedia
          overlay={
            <CardTitle
              id="card-title-skills"
              subtitle={
                <h1
                  style={{
                    color: "white",
                    fontSize: "1.3em",
                    fontWeight: 400
                  }}>
                  {this.props.skills}
                </h1>
              }
            />
          }>
          <img src={this.props.img} alt={this.props.title} />
        </CardMedia>

        <CardText
          style={{ color: "slategray", fontSize: "1em", fontWeight: 300 }}>
          {this.props.desc}
        </CardText>
        <CardText
          style={{ color: "slategray", fontSize: "0.8em", fontWeight: 300 }}>
          {this.props.features}
        </CardText>
        <CardActions>
          <RaisedButton label="Live" target="_blank" href={this.props.site} />
          <RaisedButton label="Code" target="_blank" href={this.props.code} />
        </CardActions>
      </Card>
    );
  }
}

export default Card2;



// WEBPACK FOOTER //
// ./src/components/Card/Card2.js